import { AxiosError } from 'axios';
import { AxiosService } from '../../../axios/axios.service';
import { tAxiosCustomConfig } from '../../../axios/axios.types';
import { tVerifyEmailResponse } from './SignUp.types';

export const SignUpService = {
  sendOTP: async function (userAuthId: string, phone: string): Promise<void> {
    try {
      const options = {
        headers: {
          'Auth-id': userAuthId,
        },
        isLegacy: true,
      };

      await AxiosService.post(
        `/workspaces/user/${userAuthId}/send-otp`,
        {
          phone_number: phone,
        },
        options,
      );

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  validateOTP: async function (userAuthId: string, otp: string): Promise<void> {
    try {
      const options = {
        headers: {
          'Auth-id': userAuthId,
        },
        isLegacy: true,
      };

      await AxiosService.post(
        `/workspaces/user/${userAuthId}/validate-otp`,
        {
          otp,
        },
        options,
      );

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error as AxiosError);
    }
  },

  verifyEmailExists: async function (
    email: string,
    config: tAxiosCustomConfig = {},
  ): Promise<tVerifyEmailResponse> {
    try {
      const options = {
        ...config,
        isLegacy: true,
      };

      const response = await AxiosService.get(
        `/workspaces/user/validate/emails/${email}`,
        options,
      );

      return Promise.resolve(response as tVerifyEmailResponse);
    } catch (error) {
      return Promise.reject(error as AxiosError);
    }
  },
};
